import type { OrganizationWorkingHours } from '@form-factory/schema';
import { isWithinHours } from '@form-factory/shared';
import { createContext, useContext } from 'react';

export const WorkingHoursContext =
  createContext<OrganizationWorkingHours | null>(null);

export function useWorkingHours() {
  const workingHours = useContext(WorkingHoursContext);

  return { workingHours, isOpen: isWithinHours(workingHours) };
}
